import type { ReactNode } from 'react';

import { useClientReady } from '../useClientReady';

const DefaultFallback = () => (
  <div
    className="flex h-screen w-screen items-center justify-center"
    role="status"
    aria-label="Loading"
  >
    <div
      className="h-8 w-8 animate-spin rounded-full border-4 border-current border-t-transparent opacity-50"
      aria-hidden="true"
    />
  </div>
);

/**
 * Gates rendering of children until the client is mounted and the Next.js
 * router is ready. Shows a centered spinner (or a custom fallback) while
 * waiting, preventing SSR hydration mismatches and ensuring route params
 * are available before any page component mounts.
 */
export function ClientReadyGate({
  children,
  fallback,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const clientReady = useClientReady();

  if (!clientReady) {
    return fallback ?? <DefaultFallback />;
  }

  return <>{children}</>;
}
